var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-btn',{staticClass:"editor-menubar-button",class:{ 'is-active': _vm.isActive },attrs:{"color":"tertiary","icon":"","round":""},on:{"click":_vm.command}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }